import {
  Campaign,
  Delete,
  DeleteForever,
  Edit,
  People,
  RecentActorsRounded,
  RestaurantMenu
} from "@mui/icons-material";
import {
  CloudSync as CloudSyncIcon,
  History as HistoryIcon,
  Settings as SettingsIcon
} from "@mui/icons-material";
import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Drawer,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import axios from "axios";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { SERVER_API_PREFIX } from "../../constants";
import { theme } from "../../theme";
import {
  TChange,
  THungerGame,
  TNotify,
  TPizza,
  TPizzaMenu,
  TPizzaOrder,
  TPizzaScript,
  TTab,
  TUser
} from "../../types/AllTypes";
import { emptyNotify } from "../../utils";
import { MyButton } from "../MyButton";
import { MyError } from "../Notifications";
import { Pizza, PizzaForm, PizzaMenuForm } from "../Pizza";
import { CustomersOrders } from "../PizzaOrdering";
import { NotifyForm, NotifyTemplates } from "../PushNotify";
import { User, UserEdit, UserInfo } from "../User";
import { HungerGameForm } from "./HungerGame";

export const AdminPanel = ({
  canOrder,
  setAllowLeave,
  currentUser
}: {
  canOrder: boolean;
  setAllowLeave: React.Dispatch<React.SetStateAction<boolean>>;
  currentUser: TUser | null;
}) => {
  const [countMin, setCountMin] = useState<string>("--");
  const [countSec, setCountSec] = useState<string>("--");

  const emptyHG = {
    name: "",
    deadline: new Date(),
    finished: true,
    infoText: "",
    eta: new Date(),
    pizzaLocation: "",
    pizzaMenu: { id: "", name: "", pizzas: [] },
    allowGuests: false
  };
  const [hungerGame, setHungerGame] = useState<THungerGame>(emptyHG);
  const hungerGameRef = useRef(hungerGame);
  const [editHungerGame, setEditHungerGame] = useState<THungerGame>(emptyHG);
  const [allowFinished, setAllowFinished] = useState(true);
  const [allowAllowGuests, setAllowAllowGuests] = useState(true);
  const emptyPizza = {
    name: "",
    ingredients: "",
    price: 0.0,
    pizzaMenu: { id: "", name: "", pizzas: [] },
    position: 5,
    menuId: ""
  };
  const [hungerGames, setHungerGames] = useState<THungerGame[]>([]);
  const [historyHungerGame, setHistoryHungerGame] =
    useState<THungerGame | null>(null);
  const historyHungerGameRef = useRef(historyHungerGame);
  const lastTsRef = useRef(0);

  const [users, setUsers] = useState<Record<string, TUser>>({});
  const [userEdit, setUserEdit] = useState<TUser | null>(null);
  const [userEditOpen, setUserEditOpen] = useState(false);

  {
    /* MAX 5 */
  }
  const tabs: TTab[] = [
    {
      key: "orders",
      label: "Objednavky",
      icon: <RecentActorsRounded />
    },
    {
      key: "hungergames",
      label: "HungerGames",
      icon: <HistoryIcon />
    },
    {
      key: "settings",
      label: "Nastavenia",
      icon: <SettingsIcon />
    }
  ];
  const settingsTabs: TTab[] = [
    {
      key: "menu",
      label: "Menu",
      icon: <RestaurantMenu />
    },
    {
      key: "users",
      label: "Pouzivatelia",
      icon: <People />
    },
    {
      key: "edit",
      label: "Upravit aktualne",
      icon: <SettingsIcon />
    },
    {
      key: "notifications",
      label: "Notifikacie",
      icon: <Campaign />
    },
    {
      key: "import",
      label: "Import",
      icon: <CloudSyncIcon />
    }
  ];
  // const floatingTab: TTab = {
  //   key: "orders",
  //   label: "Objednavky",
  //   icon: <RecentActorsRounded />
  // };
  // const floatingTab: TTab = {
  //   key: "undefined",
  //   label: "Objednavky",
  //   icon: <RecentActorsRounded />
  // };

  const [openTab, setOpenTab] = useState<TTab>(tabs[0]);
  const [settingsOpenTab, setSettingsOpenTab] = useState<TTab>(settingsTabs[0]);

  const [orderablePizzas, setOrderablePizzas] = useState<TPizza[]>([]);
  const [allPizzas, setAllPizzas] = useState<TPizza[]>([]);
  const [orderedPizzas, setOrderedPizzas] = useState<
    Record<string, TPizzaOrder[]>
  >({});
  const [historyOrderedPizzas, setHistoryOrderedPizzas] = useState<
    Record<string, TPizzaOrder[]>
  >({});

  const [notifyTemplatesOpen, setNotifyTemplatesOpen] = useState(false);
  const [notifyFormOpen, setNotifyFormOpen] = useState(false);
  const [notifyFormMode, setNotifyFormMode] = useState<"send" | "edit">("send");
  const [notify, setNotify] = useState<TNotify>(emptyNotify);
  const [notifyTemplates, setNotifyTemplates] = useState<TNotify[]>([]);

  const [pizzasScript, setPizzasScript] = useState<TPizzaScript[]>([]);
  const [newPizza, setNewPizza] = useState<TPizza>(emptyPizza);

  const [showOnlyValid, setShowOnlyValid] = useState(false);
  const [autoReload, setAutoReload] = useState(true);
  const autoReloadRef = useRef(autoReload);
  const [changes, setChanges] = useState<TChange[]>([]);
  const changesRef = useRef(changes);
  const canRewriteOrders = useRef(true);
  const [reloadInterval, setReloadInterval] = useState<number | null>(null);
  const reloadIntervalRef = useRef(reloadInterval);

  const [scriptOpen, setScriptOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [pizzaCreateOpen, setPizzaCreateOpen] = useState(false);
  const emptyMenu = {
    id: "",
    name: "",
    pizzas: []
  };

  const [allPizzazAreValid, setAllPizzazAreValid] = useState(true);
  const [validPizzasCost, setValidPizzasCost] = useState(0);
  const [allPizzasCost, setAllPizzasCost] = useState(0);
  const [validPizzasCount, setValidPizzasCount] = useState(0);
  const [allPizzasCount, setAllPizzasCount] = useState(0);

  const [menuFormOpen, setMenuFormOpen] = useState(false);
  const [menuFormItem, setMenuFormItem] = useState<TPizzaMenu>(emptyMenu);

  const [pizzaMenus, setPizzaMenus] = useState<TPizzaMenu[]>([]);
  const [currentPizzaMenu, setCurrentPizzaMenu] =
    useState<TPizzaMenu>(emptyMenu);
  const currentPizzaMenuRef = useRef(currentPizzaMenu);

  useEffect(() => {
    currentPizzaMenuRef.current = currentPizzaMenu;
  }, [currentPizzaMenu]);

  const findPizzaWithId = (id: string | number) => {
    const result = allPizzas.find(value => {
      return value.id == id;
    });
    if (result == undefined) {
      return {
        id: "",
        name: "Not found",
        ingredients: "Not found",
        price: 404,
        pizzaMenu: { id: "", name: "", pizzas: [] },
        position: 0,
        menuId: ""
      };
    }
    return result;
  };

  const notifyFormChange = <T extends keyof TNotify>(
    fieldChanged: T,
    newValue: TNotify[T]
  ) => {
    setNotify({ ...notify, [fieldChanged]: newValue });
  };

  const notifyFormSubmit = () => {
    axios
      .post(`${SERVER_API_PREFIX}/admin/notify`, notify)
      .then(() => {
        setNotify(emptyNotify);
        setNotifyFormOpen(false);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const notifyFormSave = () => {
    axios
      .put(`${SERVER_API_PREFIX}/admin/notification_template`, notify)
      .then(() => {
        setTimeout(async () => {
          const nottempl_response = await axios.get<TNotify[]>(
            `${SERVER_API_PREFIX}/admin/notification_templates`
          );
          setNotifyTemplates(nottempl_response.data);
        }, 100);
        setNotify(emptyNotify);
        setNotifyFormOpen(false);
      })
      .catch(error => {
        console.error(error);
        alert(error);
      });
  };

  const notifyDelete = (notify: TNotify) => {
    if (window.confirm("Naozaj chces vymazat tuto notifikaciu?")) {
      axios
        .delete(`${SERVER_API_PREFIX}/admin/notification_template/${notify.id}`)
        .then(() => {
          setTimeout(async () => {
            const nottempl_response = await axios.get<TNotify[]>(
              `${SERVER_API_PREFIX}/admin/notification_templates`
            );
            setNotifyTemplates(nottempl_response.data);
          }, 100);
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    }
  };

  const handleImport = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (
      !window.confirm(
        "Naozaj chcete importovat databazu? Vsetky aktualne data v PizzaHub budu vymazane."
      )
    ) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post<{
        status: string;
        imported: Record<string, number>;
      }>(`${SERVER_API_PREFIX}/admin/import`, formData);
      console.log("Import result:", response.data);
      alert(`Import dokonceny: ${JSON.stringify(response.data.imported)}`);
    } catch (error) {
      console.error("Import error:", error);
      alert(
        "Import zlyhal: " +
          ((
            error as {
              response?: { data?: { error?: string } };
              message?: string;
            }
          ).response?.data?.error || (error as { message?: string }).message)
      );
    }

    event.target.value = "";
  };

  const createPizzaFormChange = <T extends keyof TPizza>(
    fieldChanged: T,
    newValue: TPizza[T]
  ) => {
    setNewPizza({ ...newPizza, [fieldChanged]: newValue });
  };

  const updatePizza = (pizza: TPizza, isNew: boolean = false) => {
    axios
      .put(`${SERVER_API_PREFIX}/admin/pizza`, {
        ...pizza,
        pizzaMenu: undefined
      })
      .then(() => {
        setTimeout(async () => {
          const menuresponse = await axios.get<TPizza[]>(
            `${SERVER_API_PREFIX}/menu`
          );
          const pm_response = await axios.get<TPizzaMenu[]>(
            `${SERVER_API_PREFIX}/admin/pizza_menus`
          );
          setOrderablePizzas(menuresponse.data);
          setPizzaMenus(pm_response.data);
          if (currentPizzaMenuRef.current?.id)
            setCurrentPizzaMenu(
              getPizzaMenuWithId(
                currentPizzaMenuRef.current.id as string,
                pm_response.data
              )
            );
          if (isNew) {
            setNewPizza(emptyPizza);
            setPizzaCreateOpen(false);
          }
        }, 100);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const delPizza = (pizza: TPizza) => {
    axios
      .delete(`${SERVER_API_PREFIX}/admin/pizza/${pizza.id}`)
      .then(() => {
        setTimeout(async () => {
          const menuresponse = await axios.get<TPizza[]>(
            `${SERVER_API_PREFIX}/menu`
          );
          const pm_response = await axios.get<TPizzaMenu[]>(
            `${SERVER_API_PREFIX}/admin/pizza_menus`
          );
          setOrderablePizzas(menuresponse.data);
          setPizzaMenus(pm_response.data);
          if (currentPizzaMenuRef.current?.id)
            setCurrentPizzaMenu(
              getPizzaMenuWithId(
                currentPizzaMenuRef.current.id as string,
                pm_response.data
              )
            );
        }, 100);
      })
      .catch(error => {
        console.error(error);
        alert(error.response?.data?.error || error.message);
      });
  };

  // const delPizza = (pizza: TPizza) => {
  //   axios
  //     .delete(`${SERVER_API_PREFIX}/admin/pizza/${pizza.id}`)
  //     .then(response => {
  //       console.log(response.data);
  //       setOrderablePizzas(
  //         orderablePizzas.filter(value => value.id != pizza.id)
  //       );
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // };

  const pizzaMenuFormChange = <T extends keyof TPizzaMenu>(
    fieldChanged: T,
    newValue: TPizzaMenu[T]
  ) => {
    if (menuFormItem == null) return;
    setMenuFormItem({ ...menuFormItem, [fieldChanged]: newValue });
  };

  const pizzaMenuFormSave = () => {
    axios
      .put(`${SERVER_API_PREFIX}/admin/pizza_menu`, {
        id: menuFormItem.id,
        name: menuFormItem.name
      })
      .then(() => {
        setMenuFormItem(emptyMenu);
        setTimeout(async () => {
          const pm_response = await axios.get<TPizzaMenu[]>(
            `${SERVER_API_PREFIX}/admin/pizza_menus`
          );
          setPizzaMenus(pm_response.data);
        }, 100);
        setMenuFormOpen(false);
      })
      .catch(error => {
        console.error(error);
        alert(error);
      });
  };

  const deletePizzaMenu = () => {
    if (window.confirm("Naozaj chces vymazat toto pizza menu?")) {
      axios
        .delete(`${SERVER_API_PREFIX}/admin/pizza_menu/${currentPizzaMenu.id}`)
        .then(() => {
          setTimeout(async () => {
            const pm_response = await axios.get<TPizzaMenu[]>(
              `${SERVER_API_PREFIX}/admin/pizza_menus`
            );
            setPizzaMenus(pm_response.data);
            setCurrentPizzaMenu(hungerGameRef.current.pizzaMenu);
          }, 100);
        })
        .catch(error => {
          console.error(error);
          alert(error);
        });
    }
  };

  const editHungerGameFormChange = <T extends keyof THungerGame>(
    fieldChanged: T,
    newValue: THungerGame[T]
  ) => {
    if (editHungerGame == null) return;
    setEditHungerGame({ ...editHungerGame, [fieldChanged]: newValue });
  };

  const editHungerGameFormSave = (): Promise<boolean> => {
    return new Promise(resolve => {
      axios
        .put(`${SERVER_API_PREFIX}/admin/hunger_game`, {
          ...editHungerGame,
          pizzaMenuId: editHungerGame.pizzaMenu.id,
          pizzaMenu: undefined
        })
        .then(() => {
          setSettingsOpen(false);
          resolve(true);
        })
        .catch(error => {
          console.error(error);
          alert("ou nou");
          resolve(false);
        });
    });
  };

  const deleteHistoryHungerGame = () => {
    if (
      historyHungerGameRef.current == null ||
      !window.confirm("Naozaj chces vymazat tento hunger game?")
    )
      return;
    axios
      .delete(
        `${SERVER_API_PREFIX}/admin/hunger_game/${historyHungerGameRef.current?.id}`
      )
      .then(() => {
        setHistoryHungerGame(hungerGames[0] || null);
      });
  };

  const onPizzaCheck = (customer: string) => {
    let user_id: string | undefined = undefined;
    try {
      user_id = (JSON.parse(customer) as TUser).id;
    } catch (err) {
      user_id = undefined;
    }
    // axios
    //   .post(
    //     `${SERVER_API_PREFIX}/admin/customer`,
    //     user_id ? JSON.stringify({ id: user_id }) : customer
    //   )
    //   .then(response => {
    //     console.log(response.data);
    //     setTimeout(async () => {
    //       await fetchOrders();
    //       // setSearchedPizzas(search(searchQuery));
    //     }, 100);
    //   })
    //   .catch(() => {
    //     // console.error(error);
    //     console.log("offline edit");
    //     // alert(error);
    //     setChanges([
    //       ...changes,
    //       {
    //         url: `${SERVER_API_PREFIX}/admin/customer`,
    //         data: user_id ? JSON.stringify({ id: user_id }) : customer
    //       }
    //     ]);
    //     orderedPizzas[customer].forEach(pizza => {
    //       pizza.picked = !pizza.picked;
    //     });
    //     // setSearchedPizzas(search(searchQuery));
    //   });
    setChanges([
      ...changes,
      {
        url: `${SERVER_API_PREFIX}/admin/customer`,
        data: JSON.stringify({
          user: user_id ? JSON.stringify({ id: user_id }) : customer,
          picked:
            orderedPizzas[customer].length > 0
              ? !orderedPizzas[customer][0].picked
              : true
        })
      }
    ]);
    canRewriteOrders.current = false;
    orderedPizzas[customer].forEach(pizza => {
      pizza.picked = !pizza.picked;
    });
  };

  const onOrderEdit = (customer: string, order: TPizzaOrder) => {
    setChanges(prevChanges => [
      ...prevChanges,
      {
        url: `${SERVER_API_PREFIX}/admin/order/${order.id}`,
        data: JSON.stringify({
          custom_price: order.customPrice ?? null
        })
      }
    ]);
    canRewriteOrders.current = false;
    setOrderedPizzas(prevOrderedPizzas => ({
      ...prevOrderedPizzas,
      [customer]: (prevOrderedPizzas[customer] ?? []).map(pizza =>
        pizza.id === order.id
          ? { ...pizza, customPrice: order.customPrice }
          : pizza
      )
    }));
  };

  const updateUsersFromResponseData = (data: TUser[]) => {
    const usersMap: Record<string, TUser> = {};
    data.forEach(user => {
      usersMap[user.uid] = {
        ...user,
        wantPizzaFrom: user.wantPizzaFrom ? new Date(user.wantPizzaFrom) : null,
        restrictedUntil: user.restrictedUntil
          ? new Date(user.restrictedUntil)
          : null
      };
    });
    setUsers(usersMap);
  };

  const updateUserEdit = (
    admin: boolean,
    wantPizzaFrom: Date | null,
    restrictedUntil: Date | null
  ) => {
    if (userEdit == null) return;
    axios
      .put(`${SERVER_API_PREFIX}/admin/user/${userEdit.id}`, {
        isAdmin: admin,
        wantPizzaFrom: wantPizzaFrom ? wantPizzaFrom.toISOString() : null,
        restrictedUntil: restrictedUntil ? restrictedUntil.toISOString() : null
      })
      .then(() => {
        setTimeout(async () => {
          const users_response = await axios.get<TUser[]>(
            `${SERVER_API_PREFIX}/admin/users`
          );
          updateUsersFromResponseData(users_response.data);
        }, 100);
        setUserEdit({
          ...userEdit,
          isAdmin: admin,
          wantPizzaFrom: wantPizzaFrom,
          restrictedUntil: restrictedUntil
        });
      })
      .catch(error => {
        console.error(error);
        alert(error);
      });
  };

  const onUserViewClick = (user: TUser) => {
    setUserEdit(user);
    setUserEditOpen(true);
  };

  const resetWantPizza = () => {
    axios
      .put(`${SERVER_API_PREFIX}/admin/reset_want_pizza`)
      .then(() => {
        setTimeout(async () => {
          const users_response = await axios.get<TUser[]>(
            `${SERVER_API_PREFIX}/admin/users`
          );
          updateUsersFromResponseData(users_response.data);
        }, 100);
      })
      .catch(error => {
        console.error(error);
        alert(error);
      });
  };

  // const findPizzaWithName = (pizzas: TPizza[], name: string) => {
  //   const result = pizzas.find((value) => {
  //     return value.name == name;
  //   });
  //   if (result == undefined) {
  //     return { id: 0, name: "Not found", ingredients: "Not found", price: 404 };
  //   }
  //   return result;
  // };

  const fetchHistoryOrders = async () => {
    if (historyHungerGameRef.current == null) return;
    const response = await axios.get<Record<string, TPizzaOrder[]>>(
      `${SERVER_API_PREFIX}/admin/orders`,
      { params: { hungerGameId: historyHungerGameRef.current?.id } }
    );

    setHistoryOrderedPizzas(response.data);
  };

  const fetchOrders = async () => {
    let response;
    try {
      response = await axios.get<{
        orders: Record<string, TPizzaOrder[]>;
        order_script: TPizzaScript[];
        hunger_game: THungerGame;
        hunger_games: THungerGame[];
        pizza_menus: TPizzaMenu[];
        users: TUser[];
        notification_templates: TNotify[];
        ts: number;
      }>(`${SERVER_API_PREFIX}/admin/dashboard?ts=${lastTsRef.current}`);
    } catch (error: unknown) {
      if (axios.isAxiosError(error) && error.response?.status === 304) {
        return;
      }
      console.error(error);
      return;
    }
    const ordersData = response.data.orders as Record<string, TPizzaOrder[]>;
    const scriptData = response.data.order_script as TPizzaScript[];
    const hgData = response.data.hunger_game as THungerGame;
    const hgsData = response.data.hunger_games as THungerGame[];
    const pmsData = response.data.pizza_menus as TPizzaMenu[];
    const usersData = response.data.users as TUser[];
    const nottemplData = response.data.notification_templates as TNotify[];
    const lastTsData = response.data.ts as number;

    lastTsRef.current = lastTsData;
    setHungerGame(
      Object.keys(hgData).length > 0
        ? {
            ...hgData,
            eta: new Date(hgData.eta),
            deadline: new Date(hgData.deadline)
          }
        : emptyHG
    );
    setOrderablePizzas(hgData.pizzaMenu ? hgData.pizzaMenu.pizzas : []);
    if (canRewriteOrders.current) setOrderedPizzas(ordersData);
    setPizzasScript(scriptData);
    setPizzaMenus(pmsData);
    if (
      currentPizzaMenuRef.current?.id &&
      getPizzaMenuWithId(currentPizzaMenuRef.current.id as string, pmsData).id
    )
      setCurrentPizzaMenu(
        getPizzaMenuWithId(currentPizzaMenuRef.current.id as string, pmsData)
      );
    else if (hgData.pizzaMenu?.id)
      setCurrentPizzaMenu(getPizzaMenuWithId(hgData.pizzaMenu.id, pmsData));
    else setCurrentPizzaMenu(pmsData.length > 0 ? pmsData[0] : emptyMenu);
    setAllPizzas(
      pmsData.reduce((acc, menu) => [...acc, ...menu.pizzas], [] as TPizza[])
    );
    setHungerGames(
      hgsData.map(hg => {
        return {
          ...hg,
          eta: new Date(hg.eta),
          deadline: new Date(hg.deadline)
        };
      })
    );
    if (
      (historyHungerGameRef.current == null ||
        historyHungerGameRef.current == undefined ||
        historyHungerGameRef.current?.id === hgData.id) &&
      hgsData.length > 0
    ) {
      setHistoryHungerGame({
        ...hgsData[0],
        eta: new Date(hgsData[0].eta),
        deadline: new Date(hgsData[0].deadline)
      });
      if (hgsData[0].finished) fetchHistoryOrders();
      else setHistoryOrderedPizzas(ordersData);
    }
    updateUsersFromResponseData(usersData);
    setNotifyTemplates(nottemplData);
    // if (hungerGame) startTimer();
  };

  const areload = () => {
    const reloadIntervalcurrent = reloadIntervalRef.current;
    if (reloadIntervalcurrent == undefined) {
      const interval = setInterval(async () => {
        const autoReloadcurrent = autoReloadRef.current;
        // const reloadIntervalcurrent = reloadIntervalRef.current;
        await SendChanges();
        if (autoReloadcurrent) {
          fetchOrders();
        }
      }, 5000);
      setReloadInterval(Number(interval));
      // clearInterval(interval)
    }
  };

  const startTimer = () => {
    setInterval(() => {
      const hg = hungerGameRef.current;
      const now = new Date().getTime();
      if (hg == null) return;
      if (canOrder && hg.deadline.getTime() + 1000 >= now) {
        const timecompare = (hg.deadline.getTime() - now) / 1000;
        if (timecompare < 0) {
          setCountMin("--");
          setCountSec("--");
          setTimeout(async () => await fetchOrders(), 100);
          return;
          // canOrder = false;
          // window.location.reload();
        }

        const minutes = Math.floor(Math.floor(timecompare / 60));
        const seconds = Math.floor(
          timecompare - Math.round(Math.floor(timecompare / 60) * 60)
        );

        setCountMin(minutes.toString());
        if (seconds < 10) {
          setCountSec("0" + seconds);
        } else {
          setCountSec(seconds.toString());
        }
      }
    }, 500);
  };

  const SendChanges = async () => {
    const currentChanges = changesRef.current;
    if (currentChanges.length == 0) {
      canRewriteOrders.current = true;
      return;
    }
    canRewriteOrders.current = false;
    const nchanges: TChange[] = [];
    for (let i = 0; i < currentChanges.length; i++) {
      const element = currentChanges[i];
      console.log("sending " + element.url, element.data);
      try {
        const response = await axios.post(element.url, element.data, {
          headers: { "Content-Type": "application/json" }
        });
        console.log(response.data);
      } catch (error) {
        nchanges.push(element);
      }
      // await delay(100);
    }
    setChanges(nchanges);
  };

  const getPizzaMenuWithId = (
    id: string | number,
    pizza_menus?: TPizzaMenu[]
  ) => {
    const menus = pizza_menus ? pizza_menus : pizzaMenus;
    const pms = menus.find(value => {
      return value.id == id;
    });
    if (pms == undefined) {
      return { id: "", name: "", pizzas: [] };
    } else {
      return pms;
    }
  };

  const getHungerGameWithId = (id: string | number) => {
    const hg = hungerGames.find(value => {
      return value.id == id;
    });
    if (hg == undefined) {
      return emptyHG;
    } else {
      return {
        ...hg,
        eta: new Date(hg.eta),
        deadline: new Date(hg.deadline)
      };
    }
  };

  const isPizzaInMenu = (pizzaid: string | number, pizzaMenu: TPizzaMenu) => {
    return pizzaMenu.pizzas.find(apizza => apizza.id == pizzaid) != undefined;
  };

  // if (hungerGame) {
  //   setInterval(() => {
  //     if (canOrder) {
  //       const timecompare =
  //         (hungerGame.deadline.getTime() - new Date().getTime()) / 1000;

  //       const minutes = Math.floor(Math.floor(timecompare / 60));
  //       const seconds = Math.floor(
  //         timecompare - Math.round(Math.floor(timecompare / 60) * 60)
  //       );

  //       setCountMin(minutes.toString());
  //       if (seconds < 10) {
  //         setCountSec("0" + seconds);
  //       } else {
  //         setCountSec(seconds.toString());
  //       }
  //     }
  //   }, 500);
  // }

  useEffect(() => {
    setAllPizzazAreValid(true);
    const valid_cost = Object.keys(orderedPizzas).reduce((acc, customer) => {
      return (
        acc +
        orderedPizzas[customer].reduce((acc, pizza) => {
          const count = pizza.count ? pizza.count : 1;
          if (!pizza.valid) {
            setAllPizzazAreValid(false);
            return acc;
          }
          return acc + count * (pizza.customPrice ?? pizza.pizza.price);
        }, 0)
      );
    }, 0);
    setValidPizzasCost(valid_cost);

    const all_cost = Object.keys(orderedPizzas).reduce((acc, customer) => {
      return (
        acc +
        orderedPizzas[customer].reduce((acc, pizza) => {
          const count = pizza.count ? pizza.count : 1;
          return acc + count * (pizza.customPrice ?? pizza.pizza.price);
        }, 0)
      );
    }, 0);
    setAllPizzasCost(all_cost);

    const valid_count = Object.keys(orderedPizzas).reduce((acc, customer) => {
      return (
        acc +
        orderedPizzas[customer].reduce((acc, pizza) => {
          const count = pizza.count ? pizza.count : 1;
          if (!pizza.valid) return acc;
          return acc + count;
        }, 0)
      );
    }, 0);
    setValidPizzasCount(valid_count);

    const all_count = Object.keys(orderedPizzas).reduce((acc, customer) => {
      return (
        acc +
        orderedPizzas[customer].reduce((acc, pizza) => {
          const count = pizza.count ? pizza.count : 1;
          return acc + count;
        }, 0)
      );
    }, 0);
    setAllPizzasCount(all_count);
  }, [orderedPizzas]);

  useEffect(() => {
    autoReloadRef.current = autoReload;
  }, [autoReload]);

  useEffect(() => {
    reloadIntervalRef.current = reloadInterval;
  }, [reloadInterval]);

  useEffect(() => {
    hungerGameRef.current = hungerGame;
  }, [hungerGame]);

  useEffect(() => {
    historyHungerGameRef.current = historyHungerGame;
  }, [historyHungerGame]);

  useEffect(() => {
    if (openTab.key == "settings") {
      setEditHungerGame(hungerGame);
      setAllowFinished(true);
      setAllowAllowGuests(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openTab]);

  useEffect(() => {
    changesRef.current = changes;
    if (changes.length > 0) {
      setAllowLeave(false);
    } else {
      setAllowLeave(true);
    }
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (changes.length > 0) {
        e.preventDefault();
        e.returnValue = ""; // required for chrome
        return true;
      }
      return null;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [changes]);

  useEffect(() => {
    fetchOrders();
    if (hungerGame) {
      startTimer();
      areload();
    }
    setTimeout(() => {
      setCurrentPizzaMenu(hungerGameRef.current.pizzaMenu);
    }, 800);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const results = search(searchQuery);
  // setSearchedPizzas(results);
  return (
    <>
      <Box paddingBottom={9}>
        {openTab.key == "orders" ? (
          <>
            {hungerGame && !hungerGame.finished ? (
              <CustomersOrders
                autoReload={autoReload}
                setAutoReload={setAutoReload}
                showOnlyValid={showOnlyValid}
                setShowOnlyValid={setShowOnlyValid}
                orderedPizzas={orderedPizzas}
                orderablePizzas={orderablePizzas}
                checkButton={
                  hungerGame.deadline.getTime() < new Date().getTime()
                }
                onScriptOpen={() => setScriptOpen(true)}
                onPizzaCheck={onPizzaCheck}
                onUserViewClick={onUserViewClick}
                validPizzasCount={validPizzasCount}
                allPizzasCount={allPizzasCount}
                allUsers={users}
                editOrder={onOrderEdit}
              />
            ) : (
              <Box paddingX={2}>
                <Typography
                  variant="h4"
                  sx={{ textAlign: "center", marginY: 3 }}
                >
                  <MyButton
                    onClick={() => {
                      setEditHungerGame({ ...emptyHG, finished: false });
                      setAllowFinished(false);
                      setAllowAllowGuests(true);
                      setSettingsOpen(true);
                    }}
                    variant="contained"
                    size="large"
                  >
                    Vytvorit HungerGame
                  </MyButton>
                </Typography>
                {Object.values(users).filter(user => user.wantPizzaFrom)
                  .length > 0 ? (
                  <>
                    <Typography
                      variant="h4"
                      sx={{ textAlign: "center", marginTop: 3 }}
                    >
                      Pizzu chcu (
                      {
                        Object.values(users).filter(user => user.wantPizzaFrom)
                          .length
                      }
                      ):{" "}
                      <IconButton
                        onClick={resetWantPizza}
                        title="Reset"
                        color="error"
                      >
                        <Delete />
                      </IconButton>
                    </Typography>
                    <Grid
                      container
                      justifyContent={"center"}
                      maxWidth="1200px"
                      margin="0 auto"
                    >
                      {Object.values(users)
                        .filter(user => user.wantPizzaFrom)
                        .slice()
                        .toSorted((a, b) => {
                          if (a.isAdmin !== b.isAdmin) {
                            return b.isAdmin ? 1 : -1;
                          }
                          if (a.isOCAdmin !== b.isOCAdmin) {
                            return b.isOCAdmin ? 1 : -1;
                          }
                          return a.username.localeCompare(b.username);
                        })
                        .map(user => {
                          return (
                            <User
                              key={user.id}
                              user={user}
                              onEditClick={(user: TUser) => {
                                setUserEdit(user);
                                setUserEditOpen(true);
                              }}
                            />
                          );
                        })}
                    </Grid>
                  </>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{ textAlign: "center", marginTop: 3 }}
                  >
                    Nikto nechce pizzu
                  </Typography>
                )}
              </Box>
            )}
          </>
        ) : openTab.key == "hungergames" ? (
          <Box paddingX={2}>
            <Grid
              container
              justifyContent={"center"}
              maxWidth="1200px"
              margin="0 auto"
            >
              <Box
                display={"flex"}
                justifyContent={"center"}
                flexWrap={"wrap"}
                style={{ width: "100%" }}
                paddingX={0}
                marginX={4}
                marginBottom={1}
              >
                <MyButton
                  style={{ marginRight: 20 }}
                  color="primary"
                  onClick={() => {
                    if (historyHungerGameRef.current) {
                      setEditHungerGame(historyHungerGameRef.current);
                      setAllowFinished(false);
                      setAllowAllowGuests(false);
                      setSettingsOpen(true);
                    }
                  }}
                  title="Edit"
                  disabled={!historyHungerGameRef.current}
                >
                  <Edit />
                </MyButton>
                <MyButton
                  style={{ marginRight: 20 }}
                  color="error"
                  onClick={deleteHistoryHungerGame}
                  title="Delete"
                  disabled={!historyHungerGameRef.current}
                >
                  <DeleteForever />
                </MyButton>
                <FormControl sx={{ flexGrow: 1 }}>
                  <InputLabel id="select-history-hunger-game-label">
                    Hunger game
                  </InputLabel>
                  <Select
                    labelId="select-history-hunger-game-label"
                    id="select-history-hunger-game"
                    value={
                      historyHungerGameRef.current
                        ? historyHungerGameRef.current.id
                        : ""
                    }
                    label="Hunger game"
                    onChange={e => {
                      setHistoryHungerGame(getHungerGameWithId(e.target.value));
                      setTimeout(async () => {
                        await fetchHistoryOrders();
                      }, 100);
                    }}
                  >
                    {hungerGames.map(hg => {
                      return (
                        <MenuItem
                          key={hg.id ?? hg.deadline.toISOString()}
                          value={hg.id}
                        >
                          {hg.name == ""
                            ? hg.id
                              ? "#" +
                                hg.id +
                                " - " +
                                hg.deadline.toLocaleString()
                              : hg.deadline.toLocaleString()
                            : hg.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
              {historyHungerGameRef.current && (
                <CustomersOrders
                  autoReload={autoReload}
                  setAutoReload={setAutoReload}
                  showOnlyValid={showOnlyValid}
                  setShowOnlyValid={setShowOnlyValid}
                  orderedPizzas={historyOrderedPizzas}
                  orderablePizzas={
                    historyHungerGameRef.current.pizzaMenu.pizzas
                  }
                  checkButton={false}
                  onUserViewClick={onUserViewClick}
                  allUsers={users}
                />
              )}
            </Grid>
          </Box>
        ) : openTab.key == "settings" ? (
          <>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexWrap={"wrap"}
              style={{ width: "100%" }}
              paddingX={0}
              marginBottom={4}
            >
              {settingsTabs.map(tab => (
                <MyButton
                  key={tab.key}
                  style={{ marginTop: 8, marginRight: 20 }}
                  color={settingsOpenTab.key == tab.key ? "primary" : "inherit"}
                  onClick={() => setSettingsOpenTab(tab)}
                  title={tab.label}
                >
                  {tab.icon}
                </MyButton>
              ))}
            </Box>
            {settingsOpenTab.key == "menu" ? (
              <>
                <Grid
                  container
                  justifyContent={"center"}
                  maxWidth={"1200px"}
                  margin="0 auto"
                >
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    flexWrap={"wrap"}
                    style={{ width: "100%" }}
                    paddingX={0}
                    marginX={4}
                    marginBottom={1}
                  >
                    <MyButton
                      style={{ marginRight: 20 }}
                      color="primary"
                      onClick={() => {
                        setMenuFormItem(currentPizzaMenu);
                        setMenuFormOpen(true);
                      }}
                      title="Edit"
                    >
                      <Edit />
                    </MyButton>
                    <MyButton
                      style={{ marginRight: 20 }}
                      color="error"
                      onClick={deletePizzaMenu}
                      title="Delete"
                    >
                      <Delete />
                    </MyButton>
                    <FormControl sx={{ flexGrow: 1 }}>
                      <InputLabel id="select-pizza-menu-label">
                        Pizza menu
                      </InputLabel>
                      <Select
                        labelId="select-pizza-menu-label"
                        id="select-pizza-menu"
                        value={currentPizzaMenu ? currentPizzaMenu.id : ""}
                        label="Pizza menu"
                        onChange={e => {
                          if (e.target.value == "add") {
                            setMenuFormItem(emptyMenu);
                            setMenuFormOpen(true);
                            return;
                          } else {
                            setCurrentPizzaMenu(
                              getPizzaMenuWithId(e.target.value)
                            );
                          }
                        }}
                      >
                        {pizzaMenus.map(menu => {
                          return (
                            <MenuItem key={menu.id} value={menu.id}>
                              {menu.name}
                            </MenuItem>
                          );
                        })}
                        <MenuItem value={"add"}>Pridat</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  {currentPizzaMenu?.pizzas
                    .toSorted((a: TPizza, b: TPizza) => {
                      return (
                        a.position - b.position || a.name.localeCompare(b.name)
                      );
                    })
                    .map(pizza => {
                      return (
                        <Pizza
                          key={pizza.id}
                          pizza={{ ...pizza, pizzaMenu: currentPizzaMenu }}
                          removePizza={() => {
                            if (
                              window.confirm(
                                "Naozaj chces vymazat pizzu " +
                                  pizza.name +
                                  "? Bude vymazana iba ak si ju nikto neobjednal."
                              )
                            )
                              delPizza(pizza);
                          }}
                          editPizza={pizza => {
                            setNewPizza(pizza);
                            setPizzaCreateOpen(true);
                          }}
                          downPosition={(pizza: TPizza) => {
                            updatePizza({
                              ...pizza,
                              position: pizza.position - 1
                            });
                          }}
                          showPosition={true}
                          upPosition={(pizza: TPizza) => {
                            updatePizza({
                              ...pizza,
                              position: pizza.position + 1
                            });
                          }}
                        ></Pizza>
                      );
                    })}
                  <Box
                    padding={3}
                    paddingY={1.5}
                    width={"350px"}
                    sx={{ margin: "0 auto" }}
                  >
                    <Paper elevation={1}>
                      <MyButton
                        fullWidth
                        onClick={() => {
                          setNewPizza(emptyPizza);
                          setPizzaCreateOpen(true);
                        }}
                      >
                        <Typography
                          variant="h2"
                          color={"black"}
                          sx={{ textAlign: "center" }}
                        >
                          +
                        </Typography>
                      </MyButton>
                    </Paper>
                  </Box>
                </Grid>
              </>
            ) : settingsOpenTab.key == "users" ? (
              <>
                {Object.values(users).length > 0 ? (
                  <Box paddingX={2}>
                    <Grid
                      container
                      justifyContent={"center"}
                      maxWidth="1200px"
                      margin="0 auto"
                    >
                      {Object.values(users)
                        .slice()
                        .toSorted((a, b) => {
                          if (a.isAdmin !== b.isAdmin) {
                            return b.isAdmin ? 1 : -1;
                          }
                          if (a.isOCAdmin !== b.isOCAdmin) {
                            return b.isOCAdmin ? 1 : -1;
                          }
                          return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
                        })
                        .map(user => {
                          return (
                            <User
                              key={user.id}
                              user={user}
                              onEditClick={(user: TUser) => {
                                setUserEdit(user);
                                setUserEditOpen(true);
                              }}
                            />
                          );
                        })}
                    </Grid>
                  </Box>
                ) : (
                  <Box paddingX={2}>
                    <Typography
                      variant="h4"
                      sx={{ textAlign: "center", marginTop: 3 }}
                    >
                      Ziadny pouzivatelia
                    </Typography>
                  </Box>
                )}
              </>
            ) : settingsOpenTab.key == "edit" ? (
              <>
                {hungerGame ? (
                  <HungerGameForm
                    hungerGame={editHungerGame}
                    onChange={editHungerGameFormChange}
                    onSave={editHungerGameFormSave}
                    getPizzaMenuWithId={getPizzaMenuWithId}
                    pizzaMenus={pizzaMenus}
                    allowAllowGuests={allowAllowGuests}
                    allowFinished={allowFinished}
                    inDrawer={false}
                  />
                ) : (
                  <Box display={"flex"} justifyContent={"center"}>
                    <Typography variant="h4" sx={{ textAlign: "center" }}>
                      Nieje ziaden hunger game
                    </Typography>
                  </Box>
                )}
              </>
            ) : settingsOpenTab.key == "notifications" ? (
              <>
                <NotifyTemplates
                  notifyTemplates={notifyTemplates}
                  onSend={(notify: TNotify) => {
                    setNotify(notify);
                    setNotifyFormOpen(true);
                    setNotifyFormMode("send");
                  }}
                  onEdit={(notify: TNotify) => {
                    setNotify(notify);
                    setNotifyFormOpen(true);
                    setNotifyFormMode("edit");
                  }}
                  onDelete={notifyDelete}
                />
                <Box
                  position={"inherit"}
                  bottom={100}
                  width={"98%"}
                  marginTop={2}
                  paddingX={2}
                >
                  <MyButton
                    sx={{ width: "100%" }}
                    onClick={() => {
                      setNotify(emptyNotify);
                      setNotifyFormMode("send");
                      setNotifyFormOpen(true);
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700
                      }}
                      variant="h6"
                    >
                      Vlastne
                    </Typography>
                  </MyButton>
                </Box>
              </>
            ) : settingsOpenTab.key == "import" ? (
              <>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  width={"100%"}
                  padding={4}
                >
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Import databazy z SQLite
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2 }}
                  >
                    Nahrajte subor db.sqlite z povodneho servera. Vsetky
                    existujuce data v PizzaHub tabulkach budu vymazane a
                    nahradene.
                  </Typography>
                  <input
                    type="file"
                    id="sqlite-upload"
                    style={{ display: "none" }}
                    accept=".sqlite,.db"
                    onChange={handleImport}
                  />
                  <label htmlFor="sqlite-upload">
                    <MyButton variant="contained" component="span">
                      Vybrat subor
                    </MyButton>
                  </label>
                </Box>
              </>
            ) : (
              <Box paddingX={2}>
                <Typography
                  variant="h4"
                  sx={{ textAlign: "center", marginTop: 3 }}
                >
                  Nieco sa pokazilo
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <Box paddingX={2}>
            <Typography variant="h4" sx={{ textAlign: "center", marginTop: 3 }}>
              Nieco sa pokazilo
            </Typography>
          </Box>
        )}
        {changes.length > 0 && (
          <Fab
            sx={{
              position: "fixed",
              top: allPizzazAreValid ? 10 : 60,
              right: 10
            }}
            size="small"
            color="warning"
            aria-label="changes"
          >
            {/* <pre>{changes.toString()}</pre> */}
            <Badge badgeContent={changes.length} color="primary">
              <CloudSyncIcon color="action" />
            </Badge>
          </Fab>
        )}
        {!allPizzazAreValid && (
          <MyError
            title="Neplatna objednavka"
            desc="Niektore polozky z objednavky uz nie su dostupne. Skontrolujte
              prosim vyznacene objednavky."
          ></MyError>
        )}
        <Box position={"fixed"} bottom={0} left={0} right={0} width={"100%"}>
          <BottomNavigation showLabels>
            {/* MAX 5 */}
            {tabs.map(tab => (
              <BottomNavigationAction
                key={tab.key}
                onClick={() => setOpenTab(tab)}
                sx={openTab.key == tab.key ? { color: "primary.main" } : {}}
                label={tab.label}
                icon={tab.icon}
              />
            ))}
          </BottomNavigation>
          {hungerGame && !hungerGame.finished && (
            <Box
              display={"flex"}
              bgcolor={theme.palette.background.default}
              // fullWidth
              justifyContent={"center"}
            >
              <Typography variant="h5" sx={{ textAlign: "center" }}>
                {countMin} : {countSec}
              </Typography>
            </Box>
          )}
        </Box>

        <Drawer //User edit
          anchor={"bottom"}
          open={userEditOpen && userEdit != null}
          onClose={() => {
            setUserEditOpen(false);
          }}
        >
          <Box height={"80vh"}>
            {userEdit && (
              <>
                <UserInfo user={userEdit}></UserInfo>
                <UserEdit
                  user={userEdit}
                  onAdminToggle={() => {
                    updateUserEdit(
                      !userEdit.isAdmin,
                      userEdit.wantPizzaFrom,
                      userEdit.restrictedUntil
                    );
                  }}
                  onWantPizzaCancel={() => {
                    updateUserEdit(
                      userEdit.isAdmin,
                      null,
                      userEdit.restrictedUntil
                    );
                  }}
                  disabled={currentUser?.id == userEdit.id}
                  restrictDisabled={
                    !!(
                      currentUser?.id == userEdit.id ||
                      userEdit.isAdmin ||
                      userEdit.isOCAdmin ||
                      (currentUser &&
                        currentUser.restrictedUntil != null &&
                        currentUser.restrictedUntil > new Date())
                    )
                  }
                  onRestrictUntilChange={(newDate: Date | null) => {
                    updateUserEdit(
                      userEdit.isAdmin,
                      userEdit.wantPizzaFrom,
                      newDate
                    );
                  }}
                />
              </>
            )}
          </Box>
        </Drawer>

        <Drawer //Menu form
          anchor={"bottom"}
          open={menuFormOpen}
          onClose={() => {
            setMenuFormOpen(false);
          }}
        >
          <Box height={"80vh"}>
            <PizzaMenuForm
              pizzaMenu={menuFormItem}
              onChange={pizzaMenuFormChange}
              onSave={pizzaMenuFormSave}
            ></PizzaMenuForm>
          </Box>
        </Drawer>

        <Drawer //Script
          anchor={"bottom"}
          open={scriptOpen}
          onClose={() => {
            setScriptOpen(false);
          }}
        >
          <Box height={"80vh"}>
            <Grid
              container
              justifyContent={"center"}
              paddingBottom={20}
              maxWidth="1200px"
              margin="0 auto"
            >
              {pizzasScript
                .toSorted((a: TPizzaScript, b: TPizzaScript) => {
                  return (
                    findPizzaWithId(a.pizza_id).position -
                    findPizzaWithId(b.pizza_id).position
                  );
                })
                .map(script => {
                  return (
                    (!showOnlyValid ||
                      isPizzaInMenu(
                        script.pizza_id,
                        hungerGameRef.current.pizzaMenu
                      )) && (
                      <Pizza
                        key={`${script.pizza_id}-${script.note ?? ""}-${script.count ?? 1}`}
                        pizza={{
                          ...findPizzaWithId(script.pizza_id),
                          note: script.note
                        }}
                        count={script.count}
                        textcolor={
                          isPizzaInMenu(
                            script.pizza_id,
                            hungerGameRef.current.pizzaMenu
                          )
                            ? "text.primary"
                            : "red"
                        }
                        showPosition={true}
                      ></Pizza>
                    )
                  );
                })}
            </Grid>
            <Box
              position={"fixed"}
              bottom={0}
              paddingBottom={"20px"}
              paddingTop={"30px"}
              width={"100%"}
              paddingX={2}
              sx={{
                backgroundImage: `linear-gradient(to bottom, ${alpha(
                  theme.palette.background.paper,
                  0.0
                )} 0%, ${alpha(theme.palette.background.paper, 0.5)} 25%, ${alpha(theme.palette.background.paper, 1)} 80%)`
              }}
            >
              <Box display={"flex"} justifyContent={"center"} marginBottom={2}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, textAlign: "center" }}
                >
                  <Badge badgeContent={validPizzasCount} color="primary">
                    Spolu {validPizzasCost.toFixed(2)}€
                  </Badge>
                  {!allPizzazAreValid && !showOnlyValid && (
                    <Badge badgeContent={allPizzasCount} color="error">
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          textAlign: "center",
                          color: "red"
                        }}
                      >
                        ({allPizzasCost.toFixed(2)}
                        €)
                      </Typography>
                    </Badge>
                  )}
                </Typography>
              </Box>
              <MyButton
                fullWidth
                onClick={() => {
                  setScriptOpen(false);
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700
                  }}
                  variant="h6"
                >
                  ZAVRIET
                </Typography>
              </MyButton>
            </Box>
          </Box>
        </Drawer>
        <Drawer //Settings
          anchor={"bottom"}
          open={settingsOpen}
          onClose={() => {
            setSettingsOpen(false);
          }}
        >
          <Box height={"80vh"}>
            {hungerGame ? (
              <HungerGameForm
                hungerGame={editHungerGame}
                onChange={editHungerGameFormChange}
                onSave={editHungerGameFormSave}
                getPizzaMenuWithId={getPizzaMenuWithId}
                pizzaMenus={pizzaMenus}
                allowAllowGuests={allowAllowGuests}
                allowFinished={allowFinished}
              />
            ) : (
              <Box display={"flex"} justifyContent={"center"}>
                <Typography variant="h4" sx={{ textAlign: "center" }}>
                  Nieje ziaden hunger game
                </Typography>
              </Box>
            )}
          </Box>
        </Drawer>
        <Drawer //Notify templates
          anchor={"bottom"}
          open={notifyTemplatesOpen}
          onClose={() => {
            setNotifyTemplatesOpen(false);
          }}
        >
          <Box height={"80vh"}>
            <NotifyTemplates
              notifyTemplates={notifyTemplates}
              onSend={(notify: TNotify) => {
                setNotify(notify);
                setNotifyFormOpen(true);
                setNotifyFormMode("send");
              }}
              onEdit={(notify: TNotify) => {
                setNotify(notify);
                setNotifyFormOpen(true);
                setNotifyFormMode("edit");
              }}
              onDelete={notifyDelete}
            />
            <Box position={"fixed"} bottom={20} width={"100%"} paddingX={2}>
              <MyButton
                sx={{ width: "100%" }}
                onClick={() => {
                  setNotify(emptyNotify);
                  setNotifyFormMode("send");
                  setNotifyFormOpen(true);
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700
                  }}
                  variant="h6"
                >
                  Vlastne
                </Typography>
              </MyButton>
            </Box>
          </Box>
        </Drawer>
        <Drawer //Notify form
          anchor={"bottom"}
          open={notifyFormOpen}
          onClose={() => {
            setNotifyFormOpen(false);
          }}
        >
          <Box height={"80vh"}>
            <NotifyForm
              notify={notify}
              onChange={notifyFormChange}
              onSendAndSave={
                notifyFormMode === "send"
                  ? () => {
                      notifyFormSubmit();
                      notifyFormSave();
                    }
                  : undefined
              }
              onSend={notifyFormMode === "send" ? notifyFormSubmit : undefined}
              onSave={notifyFormMode === "edit" ? notifyFormSave : undefined}
              inDrawer={true}
            />
          </Box>
        </Drawer>
        <Drawer //Pizza create
          anchor={"bottom"}
          open={pizzaCreateOpen}
          onClose={() => {
            setPizzaCreateOpen(false);
          }}
        >
          <Box height={"80vh"}>
            <PizzaForm
              pizza={newPizza}
              onChange={createPizzaFormChange}
              onSave={() => {
                updatePizza(newPizza, true);
              }}
              getPizzaMenuWithId={getPizzaMenuWithId}
              pizzaMenus={pizzaMenus}
            ></PizzaForm>
          </Box>
        </Drawer>
      </Box>
    </>
  );
};
